import React,{ useEffect } from 'react'
import Header from './Header'
import VideoPlayer from './VideoPlayer';
import { useHistory, useLocation } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { EventTypes, trackEvent } from "../../Utils/Analytics";
import { ENV } from '../../path';


function GetHelp() {
  const location = useLocation();
  const history = useHistory();

    const data = [
        {
          Question: "How to Participate?",
          Answer:
            "Watch the video below to learn how to participate in the competition and understand the steps involved.",
          ImageLink:
            "https://blaccsckullplatformsprivatelim.box.com/shared/static/i0tiy3e6llr3hzgav45jlau4rfdencge.png",
          VideoLink:  "https://blaccsckullplatformsprivatelim.box.com/shared/static/07xhxiahsc8bdhxrfdrkyrebr79hx2gp.mp4",
        },
        {
          Question: "How will you receive prize money?",
          Answer:
            "Watch the video to follow the steps and learn how to receive the prize money directly in your bank account.",
          ImageLink:
            "https://blaccsckullplatformsprivatelim.box.com/shared/static/cxy5426i0z9iv5hrs8umq690s73fnlrz.png",
          VideoLink: "https://blaccsckullplatformsprivatelim.box.com/shared/static/3ntuqayqbdv6g72xch5gj5mcpm0s1n2n.mp4 ",
        },
        {
          Question: "How will your performance will be evaluated?",
          Answer:
            "Watch the video to follow the steps and learn how will your preformance will be evaluated by the judge.",
          ImageLink:
            "https://blaccsckullplatformsprivatelim.box.com/shared/static/bhehuldyai8a9pdo1cb3yjatxmewo6ph.png",
          VideoLink: "https://blaccsckullplatformsprivatelim.box.com/shared/static/8vbk9h55smdhn8un01d2xlp5biv6bxar.mp4 ",
        },
      ];

  const handleWhatsAppClick = () => {
    const phoneNumber = '+918956742394';
    const message = encodeURIComponent('Hello, I would like to get in touch with your team.');
    const url = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(url, '_blank');
  };

  const handleEmailClick = () => {
    const email = 'support@feedants.com';
    const subject = encodeURIComponent('Support Request');
    const body = encodeURIComponent('Hello Team,\n\nI need help with...');
    const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;
    window.location.href = mailtoLink;
  };

  useEffect(()=>{
    if(ENV === "prod"){
      trackEvent(EventTypes.PAGE_VIEW,{
        page:"get-help"
      })
    }
  },[])

    useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.substring(1);
      const el = document.getElementById(targetId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [location]);

  return (
    <div className=" h-screen w-full fixed inset-0 overflow-y-scroll bg-slate-100 font-gilroy-regular">
        <Header/>

        <div className=' w-full px-2 py-4 flex flex-col gap-4 mb-6'>
            <div className="flex flex-col bg-white rounded-xl mx-auto  w-full p-1 md:p-4 md:max-w-lg">
                <div className=" flex items-center justify-between gap-2 my-2 mb-2 px-1">
                    <h1 className=" text-xl font-semibold font-gilroy-semibold">Get help</h1>
                    <p
                    className=' flex item-center text-lg text-gray-400 cursor-pointer font-medium font-gilroy-semibold'
                    onClick={() => history.goBack()}
                  >
                    <ChevronLeftIcon className='text-gray-400'/>
                    Go Back
                  </p>
                </div>
                <div className=' flex flex-col gap-4'>
                    {data.map((item)=>(
                        <div className=" flex flex-col gap-2 px-1 " 
                        id={item?.Question.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]/g, "")}
                        key={item?.Question}>
                        <h1 className="font-semibold font-gilroy-semibold">{item?.Question}</h1>
                        <p className=" text-gray-400">{item?.Answer}</p>
                        <VideoPlayer
                            src={item?.VideoLink}
                            poster={item?.ImageLink}
                            className="h-40 w-full"
                        />
                    </div>
                    ))}
                </div>
            </div>
            <div className="flex flex-col bg-white rounded-xl mx-auto  w-full p-4 md:max-w-lg">
                <div className=" flex flex-col gap-2 my-2 mb-4">
                    <h1 className=" text-lg md:text-xl font-semibold font-gilroy-semibold">Contact Us</h1>
                    <p
                    className=' flex item-center text-sm md:text-base text-gray-500  font-medium font-gilroy-semibold'
                  >
                    
                    You can get in touch with us through below platforms. Our Team will reach out as soon as it would be possible
                  </p>
                </div>
                <div className=' flex flex-col gap-4'>
                    <div className=" flex items-center gap-4 p-2 rounded-xl hover:bg-gray-100 cursor-pointer"
                      onClick={()=>handleWhatsAppClick()}
                    >
                      <span className=" bg-gray-100 p-2 rounded-xl" >
                        <WhatsAppIcon className=" text-green-500 " />
                      </span>
                      <div className=' flex flex-col'>
                        <p className=' text-sm text-gray-400'>Whatsapp</p>
                        <p className=" font-medium font-gilroy-medium text-gray-700">+91-8956742394</p>
                      </div>
                    </div>
                    <div className=" flex items-center gap-4 p-2 rounded-xl hover:bg-gray-100 cursor-pointer"
                    onClick={()=>handleEmailClick()}
                    >
                      <span className=" bg-gray-100 p-2 rounded-xl" >
                        <EmailOutlinedIcon className=" text-gray-800 " />
                      </span>
                      <div className=' flex flex-col'>
                        <p className=' text-sm text-gray-400'>Email Address</p>
                        <p className=" font-medium font-gilroy-medium text-gray-700">support@feedants.com</p>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default GetHelp